export default __webpack_public_path__ + "static/fonts/D-DIN-PRO-400-Regular.672e06f3.otf";